import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Cargo, CargoService } from '../cargo/cargo.service';
import { CODE, CARGO_LIST_TYPE, CARGO_STATUS, LOGON_INFO, SERVER, AppConstants } from '../app.constants';
import { MessageService } from '../common/message.service';
import { MobileService } from './mobile.service';
import $ from 'jquery';


@Component({
    selector: 'search-cargo',
    templateUrl: 'search-cargo.component.html',
    providers: [CargoService, MobileService]
})
export class SearchCargoComponent implements OnInit, OnDestroy {

    cargoList: Cargo[];
    currentCargo: Cargo;
    totalCount: number = 0;

    todohukenList: any[];

    isSearchPage: boolean = true;
    isExecuteSearch: boolean = false;

    search_load_todohuken: string = '';

    login_comp_id: string;
    login_car_id: number;

    driverSocket: any;


    constructor(
        private router: Router,
        private cargoService: CargoService,
        private messageService: MessageService,
        private mobileService: MobileService
    ) {
        this.login_comp_id = LOGON_INFO.COMP_ID;
        this.login_car_id = LOGON_INFO.CAR_ID;
    }
 

    ngOnInit() {
        this.todohukenList = CODE.TODOHUKEN;

        this.driverSocket = new WebSocket(SERVER.socketURL + '/driver/');
    }


    changeSearchTodohuken() {
        if (this.search_load_todohuken) {
            this.setSearchRadiusToNouse();
        }
    }

    changeSearchRadius(radius: number) {
        if (radius != 999) {
            this.search_load_todohuken = "";
        }
    }



    async searchCargo() {
        var deviceLat: number;
        var deviceLng: number;
        
        var search_day_add = $('#search_day_add label.active input').val();
        var search_weight = $('#search_weight label.active input').val();
        var search_radius = $('#search_radius label.active input').val();

        if (search_radius != 999) {
            await this.mobileService.getDeviceCurrentLocation()
            .then(
                (data) => {
                    deviceLat = data[0];
                    deviceLng = data[1];
                }
            )
            .catch(
                (error) => {
                    search_radius = 999;
                    this.setSearchRadiusToNouse();
                    this.messageService.addInfo(error);
                }
            );
        }

        this.cargoService.searchCargoForMobile(this.search_load_todohuken, search_day_add, search_weight, search_radius, deviceLat, deviceLng)
                .subscribe(
                    data => {
                        this.isExecuteSearch = true;
                        this.cargoList = data['results'];
                        this.totalCount = data['count'];
                    }
                );
    }





    setSearchRadiusToNouse() {
        $('#search_radius input:checked').parent('.btn').removeClass('active');
        $('#search_radius input:checked').prop('checked',false);
        $('#search_radius input[value=999]').prop('checked',true);
        $('#search_radius input:checked').parent('.btn').addClass('active');
    }




    onSelect(cargo: Cargo) {
        this.currentCargo = cargo;
        this.isSearchPage = false;
    }

    backToList() {
        this.isSearchPage = true;
    }



    acceptCargo() {
        this.cargoService.acceptCargoFromDriver(this.currentCargo.id)
        .subscribe(
            data => {
                //send websocket
                this.driverSocket.send(JSON.stringify({
                    'div': AppConstants.ACCEPT,
                    'cargo_id': this.currentCargo.id
                }));

                this.router.navigate(["/mobile/report"]);
            }
        );
    }


    ngOnDestroy() {
        this.driverSocket.close();

        //Modalが開いた状態でブラウザの前ページへ移動ボタン押下すると、modalは閉じられるがbackdropが消えない
        //強制的にbackdropを消す
        $(".modal-backdrop").remove();
    }

}



// WEBPACK FOOTER //
// ./src/app/mobile/search-cargo.component.ts